import React from "react";

const NoLink = () => {
  return (
    <div class="no-match">
      <h1>No Link is Given for this League!!</h1>
    </div>
  );
};

export default NoLink;
